import { KycDetailsLog } from "src/app/kyc/kyc.model";

export class DoKycRequest {
    kycDetails: KycDetailsLog;
}

export class KycVerifyRes {
    successMsg: string;
    errMsg: string;
    returnURL: string;
    linkURL: string;
    kycRefNo: string;
    kycDetails: KycDetailsLog;
}